import React, { Suspense } from "react";
import DataSkeleton from "./data-skeleton/DataSkeleton";
import { baseUrl, getComponentFromPath } from "@kaltura/mediaspace-shared-utils";
import { KmsTypeComponent, KmsTypeHeroProps } from "@kaltura/mediaspace-shared-types";
import { ErrorBoundary } from "@kaltura/mediaspace-shared-ui";
import { useFetchKmsData } from "@kaltura/mediaspace-shared-hooks";

export type MediaLobbyDataProps = Pick<KmsTypeHeroProps, "entry" | "categoryId" | "playlist"> & {
    isReadOnly?: boolean;
};

interface MediaLobbyDataInnerProps {
    fetchMetadata: () => { components: KmsTypeComponent[] };
}

/**
 * Media Lobby Data - presenters, etc.
 */
function MediaLobbyData(props: MediaLobbyDataInnerProps) {
    const { fetchMetadata } = props;
    const lobbydata = fetchMetadata();

    return (
        <div>
            {lobbydata.components.map((component: KmsTypeComponent, index: number) => {
                const Component = getComponentFromPath(component.component);
                return (
                    <ErrorBoundary key={index} fallback={<></>}>
                        <Component {...component.props} />
                    </ErrorBoundary>
                );
            })}
        </div>
    );
}

/**
 * Media Lobby Data Suspense container
 */
export function MediaLobbyDataContainer(props: MediaLobbyDataProps) {
    const { entry, categoryId, playlist, isReadOnly = false } = props;

    // fetch data from kms
    const url =
        baseUrl
        + "/default/media/lobby-data/id/"
        + entry.id
        + (categoryId ? "/categoryid/" + categoryId : "")
        + (playlist ? "/playlistid/" + playlist.id : "");
    const fetchMetadata = useFetchKmsData<{ components: KmsTypeComponent[] }>({ url, data: { isReadOnly } }, [url]);

    // render with Suspense
    return (
        <div className="kms-ds-media-page-lobby-data-wrapper">
            <ErrorBoundary fallback={<DataSkeleton />}>
                <Suspense fallback={<DataSkeleton />}>
                    <MediaLobbyData fetchMetadata={fetchMetadata} />
                </Suspense>
            </ErrorBoundary>
        </div>
    );
}

export default MediaLobbyDataContainer;
